module.exports = __webpack_public_path__ + "img/logo.b44fd43c.webp";